export default __webpack_public_path__ + "static/media/go.10000c8c.png";